import React from 'react';
import hrazones from '@client/components/Map/geojsonFiles/hrazones.json';
import GeoJsonLayer from './GeoJsonLayer';

const HraLayer = () => (
	<GeoJsonLayer
		layerStyle={{
			id: 'hra-zones',
			type: 'fill',
			paint: {
				'fill-color': '#e8615a',
				'fill-opacity': 0.25,
				'fill-outline-color': '#ffffff',
			},
		}}
		id="hralayer-1"
		type="fill"
		data={hrazones}
	/>
);

export default HraLayer;
